import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import Typography from "@mui/material/Typography";
import {
  Button,
  Grid,
  Box,
  Divider,
  Paper,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from "@mui/material";

import { useNotificationContext } from "../../common/NotificationContext";
import { useLoading } from "../../common/LoadingContext";
import {
  convertDateDashYMD,
  padPO,
  pad,
  monthList,
  stripSecondsFromTime,
} from "../../utils/jsUtils";
import { VendorAppointmentSubmit } from "../../services/VendorAppointmentBook";
import { Close } from "@material-ui/icons";
import ConfirmationDialog from "./ConfirmationDialog";
import { appointmentConstant } from "../../utils/appointmentConstant";

const baseUrl = process.env.REACT_APP_BASE_URL;

const FinalStep = ({
  onClickNext,
  handleBack,
  setFormData,
  formData,
  materialTypeList,
  vehicleTypeList,
}) => {
  const [open, setOpen] = React.useState(false);
  const { showNotification } = useNotificationContext();
  const handleClose = () => setOpen(false);
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const formOption = {
    defaultValues: {
      ...formData,
    },
  };
  const { handleSubmit } = useForm(formOption);
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [generatedAppointment, setGeneratedAppointment] = React.useState("");

  const onSubmit = (data) => {
    setFormData({ ...formData, ...data });

    setOpen(true);
  };
  function convertDate(inputFormat) {
    if (inputFormat && inputFormat !== "") {
      let date = new Date(inputFormat);
      return [
        pad(date.getDate()),
        monthList[date.getMonth()],
        date.getFullYear(),
      ].join("-");
    }
    return "-";
  }
  const convertTime = (str) => {
    if (str) {
      const strArr = str.split(":");
      const secondstrArr = str.split(" ");
      if (secondstrArr[1] === "PM" && strArr[0] < 12) {
        return strArr[0] + 12 + ":" + strArr[1].substr(0, 2);
      } else {
        return strArr[0] + ":" + strArr[1].substr(0, 2) + ":00";
      }
    } else {
      return null;
    }
  };
  const handleClick = async (data) => {
    setFormData({ ...formData, ...data });
    // setFormData({ ...formData, ...data });
    let param = {};

    if (formData?.strategy === appointmentConstant.ARTICLE_WISE_BOX_COUNT) {
      param = {
        appointmentBookReqParam: {
          vendorCode: padPO(formData?.vendorCode),
          appointmentDate: convertDateDashYMD(formData?.appointmentDate),
          appointmentStartTime: convertTime(formData?.startTime),
          appointmentEndTime: convertTime(formData?.endTime),

          gstIn: formData?.gstin,
          countOfVehicle: formData?.vehicleDetails?.length ?? 0,
          timeSlotRefId: formData?.timeSlotRefId,
          dockId: formData?.dockId,
          fcCode: formData?.fcCode,
        },
        appointmentPoReqParams: formData?.poDetails,
        appointmentVehicleReqParams: formData?.vehicleDetails,
        appointmentStrategy: formData?.strategy,
        articleParams: formData?.selectedArticles,
      };
    } else {
      param = {
        appointmentBookReqParam: {
          vendorCode: padPO(formData?.vendorCode),
          appointmentDate: convertDateDashYMD(formData?.appointmentDate),
          appointmentStartTime: convertTime(formData?.startTime),
          appointmentEndTime: convertTime(formData?.endTime),

          gstIn: formData?.gstin,
          countOfVehicle: formData?.vehicleDetails?.length ?? 0,
          timeSlotRefId: formData?.timeSlotRefId,
          dockId: formData?.dockId,
          fcCode: formData?.fcCode,
        },
        appointmentPoReqParams: formData?.poDetails,
        appointmentVehicleReqParams: formData?.vehicleDetails,
        appointmentStrategy: formData?.strategy,
        articleParams: [],
      };
    }

    try {
      setLoading(true);
      const appointmentSubmitResponse = await VendorAppointmentSubmit(
        baseUrl,
        param
      );

      if (appointmentSubmitResponse.messageCode === 6) {
        setGeneratedAppointment({
          ...formData,
          appointmentId:
            appointmentSubmitResponse?.appointmentBookResParam?.appointmentId,
        });
        setShowConfirmation(true);
        setOpen(false);
      } else {
        showNotification(
          "Error",
          appointmentSubmitResponse?.message ??
            "Failed to Book Appointment, Please Try Again Later."
        );
      }
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed to Book Appointment, Please Try Again Later."
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Grid sx={{ background: "#fff" }}>
        <Grid item xs={12} md={12} sx={{ p: 4 }}>
          <Grid container sx={{ pl: 3, pr: 3, pt: 3, pb: 2 }}>
            <Grid item xs={12}>
              <Paper elevation={0} variant="elevation" sx={{ width: "100%" }}>
                <Box
                  sx={{
                    my: 1,
                    borderRadius: 2,
                  }}
                >
                  <Typography textAlign={"left"} variant="h6" px={3} mt={1}>
                    Appointment Details
                  </Typography>
                  <Grid container sx={{ px: 3, pt: 1, pb: 1 }}>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>Appointment Date</Typography>
                        <Typography
                          color={"primary"}
                          style={{ whiteSpace: "pre-line", fontWeight: 500 }}
                        >
                          {" "}
                          {convertDate(formData?.appointmentDate)}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>Appointment Time </Typography>
                        <Typography
                          color={"primary"}
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {" "}
                          {stripSecondsFromTime(formData?.startTime)}
                          {!!formData?.endTime && `- ${formData?.endTime}`}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>FC Name</Typography>
                        <Typography
                          style={{ whiteSpace: "pre-line", color: "#9e9e9e" }}
                        >
                          {" "}
                          {formData?.fcName}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3} textAlign={"left"}>
                      <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                        <Typography fontSize={13}>GSTIN </Typography>
                        <Typography
                          style={{ whiteSpace: "pre-line", color: "#9e9e9e" }}
                        >
                          {" "}
                          {formData?.GSTIN}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                {formData?.poDetails && formData?.poDetails?.length > 0 && (
                  <span>
                    {" "}
                    <Divider />
                    <Box
                      sx={{
                        my: 1,
                        borderRadius: 2,
                      }}
                    >
                      <Typography textAlign={"left"} variant="h6" px={3} mt={1}>
                        PO Details
                      </Typography>

                      <Grid container sx={{ px: 3, pt: 1, pb: 1 }}>
                        <TableContainer component={Paper}>
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow sx={{ backgroundColor: "#dfe3e9" }}>
                                <TableCell>
                                  <Typography fontWeight={500} fontSize={13}>
                                    PO Number
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontWeight={500} fontSize={13}>
                                    No Of Cases
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontWeight={500} fontSize={13}>
                                    Count of SKUs
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontWeight={500} fontSize={13}>
                                    Incoming Material
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            {formData?.poDetails?.map((item, index) => {
                              return (
                                <TableBody>
                                  <TableCell align="left">
                                    <Typography
                                      style={{
                                        whiteSpace: "pre-line",
                                        color: "#000",
                                      }}
                                    >
                                      {" "}
                                      {item?.poNumber ?? "-"}{" "}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography
                                      style={{
                                        whiteSpace: "pre-line",
                                        color: "#000",
                                      }}
                                    >
                                      {" "}
                                      {item?.noOfCases ?? "-"}{" "}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography
                                      style={{
                                        whiteSpace: "pre-line",
                                        color: "#000",
                                      }}
                                    >
                                      {" "}
                                      {item?.countOfSkus ?? "-"}{" "}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography
                                      style={{
                                        whiteSpace: "pre-line",
                                        color: "#000",
                                      }}
                                    >
                                      {" "}
                                      {
                                        materialTypeList.filter(
                                          (temp) =>
                                            parseInt(item?.materialTypeId) ===
                                            temp?.materialTypeId
                                        )[0]?.materialType
                                      }{" "}
                                    </Typography>
                                  </TableCell>
                                </TableBody>
                              );
                            })}
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Box>
                  </span>
                )}
                {formData?.vehicleDetails &&
                  formData?.vehicleDetails?.length > 0 && (
                    <span>
                      {" "}
                      <Divider />
                      <Box
                        sx={{
                          my: 2,
                          borderRadius: 2,
                        }}
                      >
                        <Typography
                          textAlign={"left"}
                          variant="h6"
                          px={3}
                          mt={1}
                        >
                          Vehicle Details
                        </Typography>

                        <Grid container sx={{ px: 3, pt: 1, pb: 1 }}>
                          <TableContainer component={Paper}>
                            <Table
                              sx={{ minWidth: 650 }}
                              aria-label="simple table"
                            >
                              <TableHead>
                                <TableRow sx={{ backgroundColor: "#dfe3e9" }}>
                                  <TableCell>
                                    <Typography fontWeight={500} fontSize={13}>
                                      Vehicle Type
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontWeight={500} fontSize={13}>
                                      Vehicle Registration Number
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontWeight={500} fontSize={13}>
                                      Driver Name
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontWeight={500} fontSize={13}>
                                      Driver Contact Number
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              {formData?.vehicleDetails?.map((item, index) => {
                                return (
                                  <TableBody>
                                    <TableCell align="left">
                                      <Typography
                                        style={{
                                          whiteSpace: "pre-line",
                                          color: "#000",
                                        }}
                                      >
                                        {" "}
                                        {
                                          vehicleTypeList.filter(
                                            (temp) =>
                                              item?.vehicleTypeId ===
                                              temp?.vehicleTypeId
                                          )[0]?.vehicleType
                                        }{" "}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography
                                        style={{
                                          whiteSpace: "pre-line",
                                          color: "#000",
                                        }}
                                      >
                                        {" "}
                                        {item?.vrn ?? "-"}{" "}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography
                                        style={{
                                          whiteSpace: "pre-line",
                                          color: "#000",
                                        }}
                                      >
                                        {" "}
                                        {item?.driverName ?? "-"}{" "}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography
                                        style={{
                                          whiteSpace: "pre-line",
                                          color: "#000",
                                        }}
                                      >
                                        {" "}
                                        {item?.driverContactNumber ?? "-"}{" "}
                                      </Typography>
                                    </TableCell>
                                  </TableBody>
                                );
                              })}
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Box>
                    </span>
                  )}
              </Paper>
            </Grid>
          </Grid>

          <Divider />
          <React.Fragment>
            <Box
              className="mt-4"
              sx={{ display: "flex", flexDirection: "row", pt: 2 }}
            >
              <Button variant="outlined" onClick={handleBack} sx={{ mr: 1 }}>
                Back
              </Button>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button
                type="submit"
                onClick={handleSubmit(onSubmit)}
                sx={{ mr: 1 }}
                variant="outlined"
              >
                Confirm
              </Button>
            </Box>
          </React.Fragment>
        </Grid>
      </Grid>

      {open && (
        <Dialog
          PaperProps={{
            style: {
              borderLeft: "4px #4d6fa5 solid",
            },
          }}
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" sx={{ px: 3 }}>
            <Typography variant="h6" gutterBottom>
              {"Confirm Updation"}{" "}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ px: 6, py: 5 }}>
            <Typography gutterBottom>
              Are You Sure You Wants to Submit?
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={handleClose} color="error">
              Cancel
            </Button>
            <Button
              onClick={() => {
                handleClick(formData);
              }}
              autoFocus
              color="primary"
            >
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <ConfirmationDialog
        open={showConfirmation}
        appointmentData={generatedAppointment}
        handleClose={() => {
          setShowConfirmation(false);
          navigate("/");
        }}
      />
    </>
  );
};

export default FinalStep;
